import { Box, withStyles } from '@material-ui/core';

export const WrapperBox = withStyles(({ spacing }) => ({
  root: {
    overflowX: 'auto',
    paddingBottom: spacing(2),
  },
}))(Box);

export const ButtonWrapperBox = withStyles(({ spacing }) => ({
  root: {
    marginTop: spacing(2),
  },
}))(Box);
